import { render } from "./ISwitch.vue?vue&type=template&id=3dda4675"
import script from "./ISwitch.vue?vue&type=script&lang=js"
export * from "./ISwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__